export default __webpack_public_path__ + "static/media/FamilyTonic.2d46f54aa97caf40b995d722c23af106.webp";